import React from 'react';
import { useTranslation } from 'react-i18next';
import { AvailablePopups } from 'store/app/types';
import Popup from 'components/Common/Popup/Popup';
import { useSelector } from 'react-redux';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import getDesignProductSizeGuideImage from 'store/product/selector/getDesignProductSizeGuideImage';
import isMobile from 'store/app/selector/isMobile';
import styles from './SizeGuidePopup.module.scss';

interface SizeGuideImageProps {
  productSizeGuideImage?: string;
}

export const SizeGuideImage = ({ productSizeGuideImage }: SizeGuideImageProps) => (
  <div className={styles.content}>{productSizeGuideImage && <img src={productSizeGuideImage} alt="" />}</div>
);

const SizeGuidePopup = () => {
  const { t } = useTranslation();
  const isDesktop = !useSelector(isMobile);
  const productSizeGuideImage = useSelector(getDesignProductSizeGuideImage);

  const popupTitle = isDesktop ? (
    <OpText variant="title-large-bold" color="primary-100">
      {t('txt_size_guide')}
    </OpText>
  ) : undefined;

  return (
    <Popup
      popupId={AvailablePopups.sizeGuidePopup}
      wrapperClassName={styles.popupWrapper}
      contentClassName={styles.popupContent}
      title={popupTitle}
      closeIconInContent={!isDesktop}
    >
      <SizeGuideImage productSizeGuideImage={productSizeGuideImage} />
    </Popup>
  );
};

export default SizeGuidePopup;
